export default __webpack_public_path__ + "static/media/aircraft-engine-desc.c71428a2.png";